import shortUUID from 'short-uuid'
import { Address } from './Address'

export class GiftedVoucherRedemption {

    constructor(
        public id: string,
        public giftedVoucherId: string,
        public amount: number,
        public venueId: string,
        public venueDisplayName: string,
        public dateCreated: Date,
        public dateUnredeemed: Date | null
    ) { }

    get active(): boolean {
        return this.dateUnredeemed === null
    }
}

export class GiftedVoucher {

    constructor(
        public id: string,
        public venueId: string,
        public lineItemId: string,
        public shortCode: string | null,
        public amount: number,
        public currencyCode: string,
        public expiryDate: Date | null,
        public recipientName: string | null,
        public postalDeliveryAddress: Address | null,
        public dateCreated: Date,
        public dateUpdated: Date,
        public redemptions: GiftedVoucherRedemption[] = []
    ) { }

    get code(): string {
        if (this.shortCode) {
            return this.shortCode.toUpperCase()
        }
        const translator = shortUUID()
        const base58Id = translator.fromUUID(this.id)
        return base58Id.toUpperCase()
    }

    get activeRedemptions(): GiftedVoucherRedemption[] {
        return this.redemptions.filter(redemption => redemption.active)
    }

    get redeemedAmount(): number {
        return this.activeRedemptions.reduce((total, redemption) => total + redemption.amount, 0)
    }

    get remainingAmount(): number {
        return Math.max(0, this.amount - this.redeemedAmount)
    }

    get redeemed(): boolean {
        return this.remainingAmount <= 0
    }

    get partiallyRedeemed(): boolean {
        return this.redeemedAmount > 0 && !this.redeemed
    }

    get isPostalDelivery(): boolean {
        return this.postalDeliveryAddress !== null
    }
}
